import { WizardStep } from 'Components/Wizard';
import { useIntl } from 'react-intl';
import { Form } from 'Components/nui';
import { FormattedMessage } from 'react-intl';

const Layout = ({
  form,
  formWrapper,
  product,
  productSelector,
  edit,
  orderType,
}) => {
  const { formatMessage } = useIntl();
  const fieldNames = formWrapper.getFieldNames();
  const indexedprice =
    form.getFieldsValue(['indexedprice']).indexedprice === 'true';
  return (
    <>
      <WizardStep
        title={formatMessage({
          id: 'formlayout-step-product-details',
          defaultMessage: 'Product',
        })}
      >
        {edit && (
          <Form.Item
            label={
              <FormattedMessage
                id="orderform-edit-field-product-label"
                description="Label for `product` field on edit order form"
                defaultMessage="Product"
              />
            }
            required={true}
          >
            <strong className="block mt--15 mb--10">{product.name}</strong>
          </Form.Item>
        )}
        {productSelector}

        <div className="form-cols-half-wrap">
          {fieldNames
            .filter(name => name?.startsWith('attributes'))
            .map(name => formWrapper.renderField(name))}
          {formWrapper.renderField('variants')}
          {formWrapper.renderField('origins')}
          {formWrapper.renderField('loading')}
          {formWrapper.renderField('age')}
          {formWrapper.renderField('productiondate')}
        </div>
      </WizardStep>
      <WizardStep
        title={formatMessage(
          {
            id: 'formlayout-step-bid-offer',
            defaultMessage:
              '{orderType, select, offer {Offer} bid {Bid} other {Bid/offer}}',
          },
          { orderType }
        )}
      >
        {formWrapper.renderField('division')}
        {formWrapper.renderField('realparty')}
        {formWrapper.renderField('realpartyuser')}
        {formWrapper.renderField('realbuyer')}
        {formWrapper.renderField('realbuyeruserfield')}
        {formWrapper.renderField('realseller')}
        {formWrapper.renderField('realselleruserfield')}
        {formWrapper.renderField('indexedprice')}
        {formWrapper.renderField('openprice')}
        <div className="form-cols-half-wrap">
          {indexedprice && product?.index ? (
            <>
              {formWrapper.renderField('price')}
              {product?.index?.type === 'Multiplier' && (
                <>{formWrapper.renderField('startprice')}</>
              )}
              {formWrapper.renderField('reserve_price')}
            </>
          ) : (
            <>
              {formWrapper.renderField('price')}
              {formWrapper.renderField('startprice')}
              {formWrapper.renderField('reserve_price')}
            </>
          )}
          {formWrapper.renderField('volume')}
        </div>
        {indexedprice && product?.index && (
          <>{formWrapper.renderField('indexdate')}</>
        )}
        {formWrapper.renderField('viewCustomerPrices')}
        {formWrapper.renderField('splittable')}
        {formWrapper.renderField('counteronly')}
        {formWrapper.renderField('currency')}
        {formWrapper.renderField('otherCurrencies')}

        {/* not used  */}
        {/* {formWrapper.renderField('currencyOption')}
          {formWrapper.renderField('estimateCurCurrency')} */}

        {formWrapper.renderField('privatebid')}
        {formWrapper.renderField('destinationsLabel')}
        {formWrapper.renderField('destinations')}
        {formWrapper.renderField('counterparty')}
        {formWrapper.renderField('counterparty_mode')}
        {formWrapper.renderField('expiry')}
        {formWrapper.renderField('anonymous')}
      </WizardStep>
      <WizardStep
        title={formatMessage({
          id: 'formlayout-step-delivery',
          defaultMessage: 'Delivery',
        })}
      >
        {formWrapper.renderField('toaddr')}
        {formWrapper.renderField('etd')}
        {formWrapper.renderField('etatext')}
        {formWrapper.renderField('callofftime')}
        {formWrapper.renderField('incoterms')}
        {formWrapper.renderField('locations')}
        {formWrapper.renderField('regions')}
        {formWrapper.renderField('fromaddr')}
        {formWrapper.renderField('warehouse')}
        {formWrapper.renderField('freightavailable')}
        {formWrapper.renderField('gfsi')}
        {formWrapper.renderField('export')}
        {formWrapper.renderField('halal')}
        {formWrapper.renderField('kosher')}
        {formWrapper.renderField('brands')}
        {formWrapper.renderField('productionmonth')}
        {formWrapper.renderField('exportable')}
        {formWrapper.renderField('exportdocs')}
        {formWrapper.renderField('exporttext')}
        {formWrapper.renderField('heattreatedpallets')}
        {formWrapper.renderField('heattreatedpalletstext')}
        {formWrapper.renderField('exportcountry')}
        {formWrapper.renderField('buyer')}
        {formWrapper.renderField('consignee')}
      </WizardStep>
      <WizardStep
        title={formatMessage({
          id: 'formlayout-step-other-details',
          defaultMessage: 'Other details',
        })}
      >
        {formWrapper.renderField('note')}
        {formWrapper.renderField('reference')}
        {formWrapper.renderField('comment')}
        {formWrapper.renderField('files')}
        {formWrapper.renderField('attachments')}
        {formWrapper.renderField('scheduledtime')}
      </WizardStep>
    </>
  );
};

export default Layout;
